import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { isAuthenticated } from './app/auth';
import { LanguageProvider } from './app/LanguageContext';
import { WorkspaceProvider } from './app/WorkspaceContext';
import { ThemeModeProvider } from './app/ThemeModeContext';
import { ExtensionsProvider } from './app/ExtensionsContext';
import AppLayout from './layout/AppLayout';
import ProtectedRoute from './modules/core/public/ProtectedRoute';
import ExtensionRoute from './modules/core/public/ExtensionRoute';
import ExtensionsPage from './extensions/ExtensionsPage';
import { EXTENSION_CATALOG } from './extensions/extensionRegistry';
import { appModuleRoutes } from './modules/routes';

function App() {
  return (
    <ThemeModeProvider>
      <LanguageProvider>
        <WorkspaceProvider>
          <ExtensionsProvider>
            <Router>
              <Routes>
                {appModuleRoutes.map((route) => (
                  <Route key={route.path} path={route.path} element={route.element} />
                ))}
                {EXTENSION_CATALOG.map((ext) => {
                  if (ext.nestedRoutes) {
                    const Layout = ext.nestedRoutes.Layout;
                    return (
                      <Route
                        key={ext.id}
                        path={ext.route}
                        element={
                          <ProtectedRoute>
                            <AppLayout>
                              <Layout />
                            </AppLayout>
                          </ProtectedRoute>
                        }
                      >
                        {ext.nestedRoutes.routes.map((r) =>
                          r.index ? (
                            <Route key={`${ext.id}-index`} index element={<r.Component />} />
                          ) : (
                            <Route
                              key={`${ext.id}-${r.path}`}
                              path={r.path}
                              element={<r.Component />}
                            />
                          )
                        )}
                      </Route>
                    );
                  }
                  const Page = ext.Page;
                  return (
                    <Route
                      key={ext.id}
                      path={ext.route}
                      element={
                        <ProtectedRoute>
                          <AppLayout>
                            <ExtensionRoute extensionId={ext.id}>
                              <Page />
                            </ExtensionRoute>
                          </AppLayout>
                        </ProtectedRoute>
                      }
                    />
                  );
                })}
                <Route
                  path="/extensions"
                  element={
                    <ProtectedRoute>
                      <AppLayout>
                        <ExtensionsPage />
                      </AppLayout>
                    </ProtectedRoute>
                  }
                />
                <Route path="/workspace/:workspaceId/settings" element={<Navigate to="/settings" replace />} />
                <Route
                  path="*"
                  element={
                    isAuthenticated() ? <Navigate to="/" replace /> : <Navigate to="/login" replace />
                  }
                />
              </Routes>
            </Router>
          </ExtensionsProvider>
        </WorkspaceProvider>
      </LanguageProvider>
    </ThemeModeProvider>
  );
}

export default App;
